import React from "react";
import { Table, Button, Flex } from "antd";
import { EyeOutlined } from "@ant-design/icons";
import EditableCell from "../editableCell/EditableCell"; 

const TableLeaderAttributes = (props) => {

    const columns = [
        {
            title: "Id",
            dataIndex: "lat_id",
            key: "lat_id",
            align: "center",
        },
        {
            title: "Atributo del líder",
            dataIndex: "lat_attribute",
            key: "lat_attribute",
            editable: true,
        },
        {
            title: '',
            dataIndex: 'lat_actions',
            key: 'lat_actions',
            align: "center",
            fixed: "right",
            width: 60,
            render: (text, row, index) => {
                return <Flex gap="small" wrap>
                    <Button onClick={() => setLeaderAttributeValuesToSee(row)} style={{ backgroundColor: "#293790", color: "white" }} icon={<EyeOutlined />} size={"large"} title='Ver competencia' />
                </Flex>
            }
        }
    ];

    const setLeaderAttributeValuesToSee = (lat) => {
        props.setLeaderAttributeValuesToSee(lat)
    }

    return (
        <Table
            className="custom-green-table"
            size="small"
            dataSource={props.data}
            columns={columns}
            pagination={{ pageSize: 10, position: ["bottomRight"] }}
            scroll={{ x: "max-content" }}
            components={{ body: { cell: EditableCell } }}
        />
    );
};

export default TableLeaderAttributes;
